function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 4.04,
  d: "M58.61 23.78L36.86 2.03H5.39v59.96h53.22V23.78z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 4.04,
  d: "M36.86 2.03v21.75h21.75"
});

function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+ZG9jdW1lbnQ8L3RpdGxlPjxwb2x5Z29uIHBvaW50cz0iNTguNjEgMjMuNzggMzYuODYgMi4wMyA1LjM5IDIuMDMgNS4zOSA2MS45OSA1OC42MSA2MS45OSA1OC42MSAyMy43OCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSI0LjA0Ii8+PHBvbHlsaW5lIHBvaW50cz0iMzYuODYgMi4wMyAzNi44NiAyMy43OCA1OC42MSAyMy43OCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSI0LjA0Ii8+PC9zdmc+";
export { SvgDocument as ReactComponent };